export const GET_TEACHER_COURSES_BY_CLASS_REQUEST = 'TEACHER_COURSES.GET_TEACHER_COURSES_BY_CLASS_REQUEST';
export const GET_TEACHER_COURSES_BY_CLASS_SUCCESS = 'TEACHER_COURSES.GET_TEACHER_COURSES_BY_CLASS_SUCCESS';
export const GET_TEACHER_COURSES_BY_CLASS_ERROR = 'TEACHER_COURSES.GET_TEACHER_COURSES_BY_CLASS_ERROR';

export const CLEAR_TEACHER_COURSES_BY_CLASS = 'TEACHER_COURSES.CLEAR_TEACHER_COURSES_BY_CLASS';
